// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"89a9cff7-567":"6f0852711c3b5028833f","89a9cff7-452":"0bb8c35b7c33f52c6818","89a9cff7-812":"cb30c69c130553d618b2","89a9cff7-83":"3df3aa244fb53d0947a8"}[chunkId] + ".js";
};